var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeOutside(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 100,
    viewBox: "0 0 182 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.217 79H49.7826C49.3913 79 49 78.6118 49 78.2235V73.3059C49 70.3294 51.3478 68 54.3478 68H97.6522C100.652 68 103 70.3294 103 73.3059V78.2235C103 78.6118 102.609 79 102.217 79Z",
    fill: "#00A3E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 76.5H105.5",
    stroke: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 81H105.5",
    stroke: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43 96.5C42.7239 96.5 42.5 96.7239 42.5 97C42.5 97.2761 42.7239 97.5 43 97.5V96.5ZM46.5 97V97.5C46.7761 97.5 47 97.2761 47 97H46.5ZM43 97.5H46.5V96.5H43V97.5ZM47 97V86H46V97H47Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.501 96.5C108.777 96.5 109.001 96.7239 109.001 97C109.001 97.2761 108.777 97.5 108.501 97.5V96.5ZM105.501 97V97.5C105.225 97.5 105.001 97.2761 105.001 97H105.501ZM108.501 97.5H105.501V96.5H108.501V97.5ZM105.001 97V86H106.001V97H105.001Z",
    fill: "#222222"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54 65.5H98C102.142 65.5 105.5 68.8579 105.5 73V85.5H46.5V73C46.5 68.8579 49.8579 65.5 54 65.5Z",
    stroke: "#222222"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 76.5C41.5 75.6667 42 74 44 74C46 74 46.5 75.6667 46.5 76.5",
    stroke: "#222222",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.5 76.5C105.5 75.6667 106 74 108 74C110 74 110.5 75.6667 110.5 76.5",
    stroke: "#222222",
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8434_22507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122 65.4737C122 59.3237 129.588 36.2988 134.108 23.4686C134.413 22.6024 135.621 22.5757 135.961 23.4285C140.874 35.7226 149.278 58.0622 148.993 65.4737C148.651 74.3684 141.818 78.4737 134.984 78.4737C130.2 78.4737 122 75.0526 122 65.4737Z",
    fill: "#00A3E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135 74.5V97M128 97H142M135 2C128.667 19.6667 116 57.4 116 67C116 81 128 86 135 86C145 86 155 80 155.5 67C155.946 55.4086 141.833 18.8333 135 2Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1 98L181 98",
    stroke: "#222222",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8434_22507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.687,
    height: 100,
    fill: "white",
    transform: "translate(115.312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeOutside);
export default __webpack_public_path__ + "static/media/time-outside.c0631ee185a0ce4dad3e5b8d29bb568f.svg";
export { ForwardRef as ReactComponent };